// Copyright (c) 2025 Nebularis Holdings LLC
// Licensed to Nutrx Solutions under a non-exclusive, non-transferable license.
// See IP License Agreement for usage restrictions.
// frontend/src/components/enterprise-admin/audit/GovernanceExportModal.jsx

import React from "react";
import { Button, StatusChip } from "../../../design-system/components";
import ModalShell from "../../compliance/modals/shared/ModalShell";
import ModalSection from "../../compliance/modals/shared/ModalSection";

function label(value, fallback) {
  const text = String(value || fallback || "").trim();
  return text ? text.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase()) : "—";
}

export default function GovernanceExportModal({ exportResult, onClose }) {
  if (!exportResult) return null;

  const exportRecord = exportResult.export || {};
  const payload = exportResult.payload || {};
  const status = exportRecord.export_status || "completed";

  return (
    <ModalShell
      className="enterprise-admin-modal-shell enterprise-admin-governance-export-modal"
      overlayClassName="enterprise-admin-modal-overlay"
      headerClassName="enterprise-admin-modal-header"
      bodyClassName="enterprise-admin-modal-body"
      open
      eyebrow="Governance Export"
      title="Audit export prepared"
      subtitle="The filtered governance ledger is ready for review."
      onClose={onClose}
      maxWidth="680px"
    >
      <ModalSection
        title="Export summary"
        description="This export preserves the selected filters, tenant scope, event count, and administrative traceability metadata."
        badge="Compliance ready"
        badgeTone="info"
      >
        <dl className="enterprise-admin-definition-list enterprise-admin-governance-export-facts">
          <div><dt>File name</dt><dd>{exportRecord.file_name || "governance-events.json"}</dd></div>
          <div><dt>Events</dt><dd>{exportRecord.event_count || payload.events?.length || 0}</dd></div>
          <div><dt>Status</dt><dd><StatusChip tone={status === "completed" ? "success" : "neutral"}>{label(status, "Completed")}</StatusChip></dd></div>
          <div><dt>Format</dt><dd>{label(exportRecord.export_format, "JSON")}</dd></div>
        </dl>
      </ModalSection>

      <div className="enterprise-admin-user-modal-actions">
        <Button type="button" onClick={onClose}>Done</Button>
      </div>
    </ModalShell>
  );
}
